import {
  Grid,
  Divider as MuiDivider,
  Typography as MuiTypography,
} from "@material-ui/core";

import ApplicationCards from "./ApplicationCards";
import { Helmet } from "react-helmet-async";
import React, { useState } from "react";
import { spacing } from "@material-ui/system";
import styled from "styled-components/macro";
import useLocale from "../../../hooks/useLocale";

import ls from "local-storage";

import { Redirect } from "react-router-dom";

const Divider = styled(MuiDivider)(spacing);

const Typography = styled(MuiTypography)(spacing);

const ExternalUserDashBoard = () => {
  const { t } = useLocale();
  const [gdprDialogPop] = useState(parseInt(ls("gdpr_accept")) === 0);

  return (
    <>
      {gdprDialogPop ? (
        // <GdprPage />
        <Redirect to="/gdprpage" />
      ) : (
        <>
          <Helmet title={t("Dashboard")} />
          <Grid justifyContent="space-between" container spacing={6}>
            <Grid item>
              <Typography variant="h3" gutterBottom>
                {t("Dashboard")}
              </Typography>
              <Typography
                variant="subtitle2"
                color="textSecondary"
                gutterBottom
              >
                {t(
                  'Choose the kind of application you would like to submit and press "New Application" to start'
                )}
              </Typography>
            </Grid>
          </Grid>

          <Divider my={6} />
          {/* <GovGrModal
            open={open}
            primaryButtonProps={{
              buttonAction: () => {
                setOpen(false);
              },
              buttonText: t("Confirm"),
            }}
            secondaryButtonProps={{
              buttonAction: () => onClose(),
              buttonText: t("Cancel"),
            }}
            textMessage={t(
              "Please confirm that it has been updated regarding the required supporting documents " +
                "which you will need to upload in order " +
                "to successfully complete your registration for the service"
            )}
            customContent={false}
          /> */}
          <ApplicationCards />
        </>
      )}
    </>
  );
};

export default ExternalUserDashBoard;
